"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useCopyToClipboard = void 0;
var react_use_clipboard_1 = __importDefault(require("react-use-clipboard"));
var useCopyToClipboard = function (text, successDuration) {
    var _a = (0, react_use_clipboard_1["default"])(text, {
        successDuration: successDuration || 700
    }), isCopied = _a[0], copyToClipboard = _a[1];
    return { copyToClipboard: copyToClipboard, isCopied: isCopied };
};
exports.useCopyToClipboard = useCopyToClipboard;
